module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYzkyMTMyNjYzM2M0NTdhZjAzYmIyNTNlNDY5NmZlZmYucG5nIjs="